
import { defineComponent, reactive, toRefs } from 'vue';
import { QrDropzone } from '../../../dist/vue3-qr-reader.common'

export default defineComponent({
  name: 'QrDropzoneExample',
  components: {
    QrDropzone
  },
  setup() {
    const state = reactive({
      data: null
    })
    function onDecode(data) {
      state.data = data
    }
    return {
      ...toRefs(state),
      onDecode
    }
  }
});
